exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Keyboard-module__wrapper___1fRsS{display:grid;justify-items:center}.Keyboard-module__wrapper___1fRsS .Keyboard-module__text___Ou56i{background:#fff;padding:.3em;border-radius:4px}.Keyboard-module__wrapper___1fRsS .Keyboard-module__keys___3qKLl{transform:translateY(calc(var(--app-height)*0.4))}", ""]);

// exports
exports.locals = {
	"wrapper": "Keyboard-module__wrapper___1fRsS",
	"text": "Keyboard-module__text___Ou56i",
	"keys": "Keyboard-module__keys___3qKLl"
};